import React from "react";
import {Helmet} from "react-helmet";

export default function BatAndHorse() {
    return (
        <div>
            <Helmet>
                <title>宁愿做笨蛋 Would Rather Be A Fool</title>
            </Helmet>
            <h6 className="App-essay-title">宁愿做笨蛋</h6>
            <p className="App-essay-article">
                <br/>
                <b>二〇二五 十一月</b>
                <br/><br/>
                <b>谁理解得深？</b>
                <br/><br/>
                两个人，都是第一次接触某样新知识。同时给他们一页纸的内容，让二人同时看30分钟，然后测试。测试有两种题目，选择题和表述题。
                <br/><br/>
                第一个人学的很快，过目不忘，所有试卷上的选择题都一遍答对，但在表述题中则水平有限。
                <br/><br/>
                第二个人正相反，记错了一些知识点，甚至漏答了一些选择题，但这个人在问答题中作答流畅，对那页纸的知识内容做了完整的描述，甚至提了更多问题。
                <br/><br/>
                哪个人对知识的理解更强？
                <br/><br/>
                从选择题的结果看，第一个人的学习水平（甚至智力水平）超过第二人。但从表述题看，第二个人对这页纸内容的深层理解能力，超过第一个人。
                <br/><br/>
                如果看总分，第一个人的得分比第二个人高。
                <br/><br/>
                <b>浅层学习 v.s. 深层学习</b>
                <br/><br/>
                第一个人博闻强记，TA把大量精力放在记忆知识本身上，学习中主要关注的对象是文本符号（Sign）。TA的神经通路是文本的打印机，而缺乏对知识结构的根本描述。如果把测试范围换成这页纸外的内容，第一个人会迅速丧失所有已知的信息。
                <br/><br/>
                第二个人，就算提问这页纸之外的内容，TA所理解的深度和内涵不会发生太大变化。已知的错误细节依旧错误，正确的依然正确，而关于那页纸的基本结构，已被TA拓展到了那页纸外。
                <br/><br/>
                <b>到底谁理解得更深？</b>
                <br/><br/>
                如果从分数上看，是第一个人。但更有可能是第二个。
                <br/><br/>
                因为虽然第一个人学得很快，但几十分钟过后，TA的脑子就会把刚才所有的信息碎片都还回去，这是对文本符号的浅层学习。而第二个人在数周甚至数年之后（甚至那页纸之外的知识）的情景下，依然理解的更“深”。
                <br/><br/>
                学校里的好学生，职场上的优秀工作者，一般都很缺乏创造力，因为仅仅搬运符号本身不产生任何新的价值。人的精力很有限，浅层处理和深层处理的能力此消彼长，除非社会变革强烈地需要TA们超长发挥，多线操作也支持不了多久。
                <br/><br/>
                当我们记得越多越准确，我们懂得反而越少越浅薄。
                <br/><br/>
                这很反常，但很真实。想想碎片化的社交媒体里，有多少信息被我们记忆，而非理解？又有多少知识被知道，而未被实践？
                <br/><br/>
                被AI快进的世界，人需要更多地知道：学到了“什么”，而不是学到了“多少”。
                <br/><br/>
                深层学习的能力来源于两个根本的冲动：求知欲和好奇心。求知欲让TA难以妥协，好奇心迫使TA探索意义(meaning)，而非符号(sign)。
                <br/><br/>
                生活中八面玲珑、反应敏捷的人，千万别高估TA们的能力，TA们的行为只是在简单模仿想象中的“聪明”是什么。
                <br/><br/>
                十年前浅层学习的能力还有不少用处，但今天只要有电有网络，AI会把这种拥有信息的优势，消解地一文不值。
                <br/><br/>
                能完美记忆知识和执行任务的人，是无意识的工具和Agent，TA们只是在不自觉地模仿“聪明”该有的“样子”——知道得多，记得牢，算得快，精确无误。
                <br/><br/>
                那个看书慢，思考走神，压根不在乎打分表，也总问出更多问题的人，是唯一真正在思考的人。
                <br/><br/>
                宁愿做笨蛋。

                <br/><br/><br/>

                <hr/>

                <b>Reference</b>
                <br/>
                1. <a href="https://bpspsychub.onlinelibrary.wiley.com/doi/abs/10.1111/j.2044-8279.1976.tb02980.x">ON QUALITATIVE DIFFERENCES IN LEARNING: I—OUTCOME AND PROCESS, F. MARTON, R. SÄLJÖ.</a>


            </p>

            <br/>

            <h6 className="App-essay-title">Would Rather Be A Fool</h6>
            <p className="App-essay-article">
                <br/>
                <b>Nov 2025</b>
                <br/><br/>

            </p>
        </div>)
}
